import { HTTP_INTERCEPTORS, HttpInterceptor } from '@angular/common/http';
import { InjectionToken, NgModule } from '@angular/core';

import { HttpCachingInterceptor } from './http-caching.interceptor';
import { JWT_HTTP_INT_CONFIG, JwtHttpIntConfigDefault } from './jwt-http-int-config';
import { JwtHttpInterceptor } from './jwt-http.interceptor';

export const JWT_HTTP_INTERCEPTOR = new InjectionToken<HttpInterceptor>('JwtHttpInterceptor');

@NgModule({
  providers: [
    { provide: JWT_HTTP_INT_CONFIG, useClass: JwtHttpIntConfigDefault },
    { provide: JWT_HTTP_INTERCEPTOR, useClass: JwtHttpInterceptor },
    { provide: HTTP_INTERCEPTORS, useExisting: JWT_HTTP_INTERCEPTOR, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpCachingInterceptor, multi: true }
  ]
})
export class InterceptorsModule {

}
